import { InputWorkspaceInviteLink } from './InputWorkspaceInviteLink';
import { WCheckboxEnableInviteByLink } from './WCheckboxEnableInviteByLink';
import { W_CHECKBOX__refresh_link_after_usage } from './W_CHECKBOX__refresh_link_after_usage';

import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export const ViewWorkspaceInviteLink = () => {
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  if (workspace_current.is_personal) return <></>;

  return (
    <>
      <span className="text-xl">{t(i18n_page_settings_workspace.tabs.users.shared.invite_by_link_component.title)}</span>

      <WCheckboxEnableInviteByLink />
      <W_CHECKBOX__refresh_link_after_usage />
      <InputWorkspaceInviteLink />
    </>
  );
};
